<template>
  <div v-if="isOpen" class="fixed inset-0 z-50 flex items-center justify-center">
    <!-- Backdrop -->
    <div class="absolute inset-0 bg-black/50" @click="close"></div>

    <!-- Modal -->
    <div
        class="relative bg-white dark:bg-card rounded-lg shadow-xl max-w-md w-full mx-4 overflow-hidden animate-fade-in">
      <!-- Header -->
      <div class="px-6 py-4 border-b border-gray-200 dark:border-border">
        <h3 class="text-xl font-bold text-gray-900 dark:text-white">Thêm lượt</h3>
      </div>

      <!-- Body -->
      <div class="px-6 py-6">
        <input
            id="orderNumber"
            v-model="orderNumber"
            type="text"
            class="w-full px-4 py-2 border border-gray-300 dark:border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            placeholder="Nhập mã đơn hàng"
            :disabled="isLoading" maxlength="20"
        />
        <p v-if="errorMessage"
           class="mt-4 text-base font-semibold text-red-600 dark:text-red-500 whitespace-pre-line leading-5">
          {{ errorMessage }}
        </p>

        <p v-if="successMessage"
           class="mt-4 text-base font-semibold text-green-600 dark:text-green-600 whitespace-pre-line leading-5">
          {{ successMessage }}
        </p>
      </div>

      <!-- Footer -->
      <div class="px-6 py-4 border-t border-gray-200 dark:border-border flex justify-between">
        <button
            @click="close"
            class="px-6 py-2 mr-2 text-sm font-bold text-gray-600 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-500 dark:border-gray-600 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 hover:cursor-pointer focus:outline-none"
            :disabled="isLoading"
        >
          Hủy
        </button>
        <button
            @click="validateOrderNumber"
            class="px-4 py-2 text-md font-bold text-white bg-primary border border-transparent rounded-md hover:bg-primary/80 hover:cursor-pointer focus:outline-none"
            :disabled="isLoading || !orderNumber"
        >
          <span v-if="isLoading" class="flex items-center">
            <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
                 viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Đang xử lý...
          </span>
          <span v-else>Xác nhận</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref, defineEmits} from 'vue';
import {useAuthStore} from "@/stores/auth.ts";
import minigameRequests from "@/utils/minigameRequests.ts";
import {toast} from "vue3-toastify";

const emit = defineEmits(['close', 'success']);

const isOpen = ref(true);
const orderNumber = ref('');
const isLoading = ref(false);
const errorMessage = ref('');
const successMessage = ref('');
const auth: any = useAuthStore();

// Close the modal
function close() {
  isOpen.value = false;
  emit('close');
}

// Validate the order number
async function validateOrderNumber() {
  if (!orderNumber.value) return;

  isLoading.value = true;
  errorMessage.value = '';
  successMessage.value = '';

  try {
    // Call API to validate the order number
    const {data} = await minigameRequests.addTurn(orderNumber.value);

    auth.minigame = data.Minigame

    successMessage.value = 'Bạn đã thêm lượt chơi thành công!'
    toast.success("Chúc mừng bạn đã thêm lượt thành công!")
    emit('success');
  } catch (error: any) {
    // Handle API error
    errorMessage.value = error.errors?.OrderNumber?.join('\n') || 'Đã xảy ra lỗi. Vui lòng thử lại sau.';
  } finally {
    isLoading.value = false;
  }
}
</script>

<style scoped>
.animate-fade-in {
  animation: fade-in 0.3s ease-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
